import { T }         from 'defa-object';
import ControlModule from 'scripts/poppet/control-module';
import template      from './controlDigiHeat.jst.html';
import { Vue }       from 'vue/defavue';

const actionOptions     = [
	{ value: 'AUTO',   title: T.tc('DigiHeat', 'AUTO' ), 	titleContext: 'DigiHeat' },
	{ value: 'OUT',    title: T.tc('DigiHeat', 'OUT' ), 	titleContext: 'DigiHeat' },
	{ value: 'STOP',   title: T.tc('DigiHeat', 'STOP' ), 	titleContext: 'DigiHeat' },
	{ value: 'LOCAL',  title: T.tc('DigiHeat', 'LOCAL' ),	titleContext: 'DigiHeat' }
];

export const ControlDigiHeatView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	
	className: function () {
		return this._getClassName( 'control-digiheat' );
	},
	
	onDomRefresh() {
		let self   = this;
		
		let slider = new Vue ({
			el: '#digiheat-slider',
			
			bb() {
				return {
					model: self.model,
				};
			},
			
			data() {
				return {
					digiHeatModeValue: 'AUTO',
					actionOptions,
				}
			},
			methods : {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= newValue;
					self.save( data )
				},
			},
			watch: {
				'model.digiHeatMode': function (newAttribute){
					this.digiHeatModeValue = JSON.parse(JSON.stringify(newAttribute));
				}
			},
			
			created() {
				if(this.model.digiHeatMode){
					this.digiHeatModeValue = JSON.parse(JSON.stringify(this.model.digiHeatMode))
				}
			}
		});
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	save: function(attributes) {
		let self = this;
		self.model.set('isValidData', false);
		try {
			this.model.save(attributes, {
				patch: true,
				isSaving: true,
				success: function() {
					console.log( Object.keys(attributes)[0] +' was succesfully saved!' );
				},
				error: function(model, response) {
					console.error( Object.keys(attributes)[0] + ' failed saving with error: ' + response.responseJSON.message );
				}
			});
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	}
});

export default  ControlDigiHeatView;
